/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Pipeline } from '@blend/search-client';

export const getColumnConfigurations = (): string[] => {
  return ['Notary.name', 'Notary.state', 'Notary.email', 'Notary.phoneNumber', 'Notary.status'];
};

export const getColumnSchemas = (): { [field: string]: Pipeline.FieldSchema } => ({
  'Notary.email': {
    displayName: 'Email',
    initialColWidth: 160,
    sortable: false,
  },
  'Notary.name': {
    displayName: 'Name',
    initialColWidth: 160,
    sortable: false,
  },
  'Notary.phoneNumber': {
    displayName: 'Phone Number',
    initialColWidth: 110,
    sortable: false,
  },
  'Notary.state': {
    displayName: 'State',
    initialColWidth: 40,
    sortable: false,
  },
  'Notary.status': {
    displayName: 'Status',
    initialColWidth: 72,
    sortable: false,
  },
});
